export const ADMIN_COLORS = {
  green: "#0e5604",
  greenBg: "#e7f6ef",
  border: "#e5e3dc",
  bgSurface: "#f7f6f2",
  bg: "#fdfdfb",
  text: "#1a1a1a",
  textMuted: "#6b6b6b",
  textFaint: "#a0a0a0",
  red: "#dc2626",
  redBg: "#fef2f2",
  amber: "#b45309",
  amberBg: "#fffbeb",
  blue: "#2563eb",
  blueBg: "#eff6ff",
};